<template>
  <mdb-row>
    <mdb-col col="12">
      <h4 class="mb-5 mt-4 dark-grey-text font-bold">
        <strong>{{ $t("basic_statistics_header") }}</strong>
      </h4>
    </mdb-col>
    <mdb-col
      xl="4"
      md="4"
      class="mb-r"
      v-for="(item, index) in basicstatistics"
      v-bind:index="index"
      v-bind:key="index"
    >
      <SquareStatistic :statistic="item" />
    </mdb-col>
  </mdb-row>
</template>

<script>
import SquareStatistic from "@/components/SquareStatistic.vue";
import { mdbCol, mdbRow } from "mdbvue";
export default {
  name: "BasicStatisticsRow",
  props: {
    basicstatisticspath: String,
  },
  components: {
    SquareStatistic,
    mdbCol,
    mdbRow,
  },
  data: () => ({
    basicstatistics: [],
  }),
  methods: {
    fetchBasicStatistics() {
      this.$http
        .get(this.basicstatisticspath + this.$store.getters.getToken)
        .then((response) => {
          if (response.status == 200) {
            console.log(response.data);
            this.basicstatistics = response.data;
            console.log(response.data);
          } else if (response.status == 401) {
            this.$root.$emit("session_failed");
          }
        })  
        .catch((error) => {
          console.log(error);
          return error;
        })
        .finally(() => (this.loading = false));
    },
  },
  mounted() {
    this.fetchBasicStatistics();
  },
};
</script>

<style>
</style>